import QRCodeRedirect from "./QRCodeRedirect";

export default QRCodeRedirect;
